import { SkeletonLoader } from "../SkeletonLoader";

export const ReferralLinkWidgetSkeleton = () => (
  <div
    data-testid="referral-link-widget-skeleton"
    className="flex flex-col gap-10 rounded-2xl border border-stroke-primary bg-surface-base-background p-6 lg:p-8"
  >
    <div className="flex items-center justify-between">
      <SkeletonLoader width={144} height={24} variant="rounded" />
      <SkeletonLoader width={128} height={20} variant="rounded" />
    </div>

    <SkeletonLoader height={40} variant="rounded" />

    <div className="flex items-center justify-center gap-6">
      <SkeletonLoader width={128} height={40} variant="rounded" />
      <SkeletonLoader width={128} height={40} variant="rounded" />
    </div>
  </div>
);
